const flashcardFlip = () => {
    window.addEventListener('click', (e) => {
        let card = e.target.closest('.flashcard-item');
        let flipBtn = e.target.closest('.flip-btn');
        if(flipBtn){
            flipBtn.closest('.flashcard-item').classList.toggle('flipped');
        }
    });
}

export {flashcardFlip};
